<template>
  <v-container fluid>
    <v-row>
    <v-col lg="8" offset-lg="2" col="12">
      <v-container >
        <v-row>
          <v-col cols="12" sm="12" md="4" lg="4" v-for="(data, index) in dataIntro" :key="index">
            <v-card flat >
              <v-card-text>
                <v-img
                  :src="require('../assets/images/'+ data.image)"
                  lazy-src="../assets/images/before-show.jpg"
                  style="width: 100px; height: auto; margin: 0 auto;"
                />
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
                <div style="text-align: center;" :class="styleFontTopic">
                  <h4 style="padding-top: 10px; font-weight: bold;" v-html="data.text"></h4>
                </div>
              </v-card-text>

              <v-expand-transition v-if="index == 0 || index == 1">
                <div class="detail">
                  <v-divider></v-divider>
                  <v-card-text v-for="(detail, detailIndex) in data.details" :key="detailIndex">
                    <span v-html="detail" :class="styleFontBody"></span>
                  </v-card-text>
                </div>
              </v-expand-transition>
              <v-expand-transition v-if="index == 2">
                <div class="detail">
                  <v-divider></v-divider>
                  <v-card-text>
                    <ol>
                      <li
                        v-for="(detail, detailIndex) in data.details"
                        :key="detailIndex"
                        :class="styleFontBody"
                      >{{detail}}</li>
                    </ol>
                  </v-card-text>
                </div>
              </v-expand-transition>
              <v-expand-transition v-if="index == 3">
                <div class="detail">
                  <v-divider></v-divider>
                  <v-card-text v-for="(detail, detailIndex) in data.details" :key="detailIndex">
                    <span v-html="detail"></span>
                  </v-card-text>
                </div>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
const axios = require("axios").default;
export default {
  name: "Intro",
  components: {},
  data() {
    return {
      showOne: false,
      showTwo: false,
      showThree: false,
      show: false,
      lang: this.$route.params.lang,
      dataIntro: [],
      styleFontTopic: {},
      styleFontBody: {}
    };
  },
  methods: {
    loadData() {
      let self = this;
      axios
        .get("/data/intro/"+this.lang+".json")
        // eslint-disable-next-line no-unused-vars
        .then(function(res) {
          self.dataIntro = res.data;
        });
    },
    loadStyle() {
      if (this.lang == 'th') { 
        this.styleFontTopic = {"th": true, "th-topic": true};
        this.styleFontBody = {"th": true};
      }
    }
  },
  mounted() {
    this.loadData();
    this.loadStyle();
  },
  watch: {
    showOne: {
      handler(value) {
        if (value == true) {
          this.showTwo = false;
          this.showThree = false;
        }
      }
    },
    showTwo: {
      handler(value) {
        if (value == true) {
          this.showOne = false;
          this.showThree = false;
        }
      }
    },
    showThree: {
      handler(value) {
        if (value == true) {
          this.showOne = false;
          this.showTwo = false;
        }
      }
    }
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #b2a358;
}
ul,
li {
  /* list-style-type: none; */
  text-align: left;
}
.detail {
  /* background-color: #b3a258; color: #fff; */
  text-align: left;
}
</style>